module.exports = __webpack_public_path__ + "static/media/LogoSestu.49070d40.png";